import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Trash } from "lucide-react";
import { Survey, SurveyTypes } from "@/models/survey.model";
import { uuid } from "@/interfaces";

interface SurveyCardProps {
  task: Survey;
  onDelete: (id: uuid) => void;
}

const getBadgeClasses = (type: SurveyTypes | string) => {
  const caseType: string = type.toString();
  switch (caseType) {
    case "text":
      return "text-blue-500 border border-blue-500 bg-blue-50";
    case "boolean":
      return "text-orange-500 border border-orange-500 bg-orange-50";
    case "select":
      return "text-green-500 border border-green-500 bg-green-50";
    default:
      return "text-gray-500 border border-gray-300 bg-gray-50";
  }
};

const getBagdeText = (type: SurveyTypes | string) => {
  const caseType: string = type.toString();
  if (caseType === "boolean") return "Yes/No";
  return caseType;
};

export function SurveyCard({ task, onDelete }: SurveyCardProps) {
  return (
    <div className="flex flex-col gap-2 bg-muted rounded-md p-2">
      <div className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <Badge className={`uppercase rounded-[3px] text-xs font-medium w-fit ${getBadgeClasses(task.answer_type)}`}>
            {getBagdeText(task.answer_type)}
          </Badge>
          <span className="text-sm text-muted-foreground">{task.question}</span>
        </div>

        {/* TODO change to delete dialog*/}
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(task.id)}
          aria-label={`Delete task: ${task.question}`}
          className="text-red-500 hover:text-red-700 hover:bg-red-100"
        >
          <Trash className="h-4 w-4" />
        </Button>
      </div>

      {Array.isArray(task.options) && task.options.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {task.options.map((option: string, index: number) => (
            <div
              key={index}
              className="px-3 py-1 text-xs rounded-full bg-muted text-muted-foreground border border-muted"
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
